import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col, Form, FormGroup, InputGroup, InputGroupText, Input, Modal,
} from "reactstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons from react-icons

// core components

// index page sections


import {RiUser3Line} from "react-icons/ri";
import {resetPassword} from "../../components/helpers/UserHelpers";
import withNavigateHook from "../../hooks/withNavigationHook";
import {useParams} from "react-router-dom";
import {SeoHelper} from "../../components/helpers/SeoHelper";

class PasswordResetRequestConfirmation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      password: "",
      passwordConfirm: "",
      showPassword: false,         // Toggle flag for password visibility
      showPasswordConfirm: false,  // Toggle flag for confirm password visibility
    }

    // createPaymentIntent("single_test", 500);

    // this.setState({songBookCount: songBookCount()});
  }

  componentDidMount() {
    const { userId, resetCode } = this.props.params;

    this.setState({
      userId: userId,
      resetCode: resetCode
    })
  }

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
        showPassword: !prevState.showPassword,
    }));
};

togglePasswordConfirmVisibility = () => {
    this.setState((prevState) => ({
        showPasswordConfirm: !prevState.showPasswordConfirm,
    }));
};

  onChangePassword = (e) => {
    this.setState({
      password: e.target.value,
      passwordError: "",
    });
  };

  onChangePasswordConfirm = (e) => {
    this.setState({
      passwordConfirm: e.target.value,
      passwordConfirmError: this.state.email === this.state.passwordConfirm ? "" : "* Passwords must match",
    });
  };

  resetButtonAvailable = () => {
    return (
        this.state.userId &&      // set by the url
        this.state.resetCode &&   // set by the url
        this.state.password &&
        this.state.passwordConfirm &&
        this.state.password === this.state.passwordConfirm
    );
  }

  validateAndSubmitForm = () => {
    this.setState({formSubmitted: true});
    let formHasError = false;

    if (!this.state.password || this.state.password.trim().length === 0) {        // TODO: valid email test
      this.setState({passwordError: "* You must provide an email address"})
      formHasError = true;
    }

    if (!this.state.passwordConfirm || this.state.passwordConfirm.trim().length === 0) {        // TODO: valid email test
      this.setState({passwordConfirmError: "* Passwords must match"})
      formHasError = true;
    }

    if (!formHasError) {
      resetPassword(this.state.userId, this.state.resetCode, this.state.password).then(result => {
          if (result) {
            sessionStorage.removeItem("customer");
            this.toggleModal("formModalResetConfirmed");
          } else {
            this.toggleModal("formModalResetIssue");
            // this.setState({generalError: "Something went wrong, please retry!"});
            // this.setState({formSubmitted: false});
          }
        }
      );
      // this.props.navigation('/register/billing');
    } else {
      this.setState({formSubmitted: false});
    }
  }

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  toggleModalAndMoveToHome = (state) => {
    this.setState({
      [state]: !this.state[state],
    });

    this.props.navigation('/');
  };

  render() {
    return (
      <>

        <SeoHelper
          title = "Password Reset Request Sent"
          noindex={true}
        />
        
        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>password reset</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-warning rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-planet" />*/}
                          {/*</div>*/}
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                <RiUser3Line color='#5e72e4' size="36"/>&nbsp;Reset password
                              </h2>
                              <p className="description mt-3">
                                {/*Sign in and build your curated song-flows*/}
                              </p>
                            </Col>
                          </Row>
                          { (!this.state.userId || !this.state.resetCode) && <>
                            <p className="description mt-3 text-warning">
                              Something has gone wrong!  Please retry the link in the email to reset your password
                            </p>
                          </>
                          }
                          { this.state.userId && this.state.resetCode && <>
                            <p className="description mt-3">
                              New password
                            </p>
                            <Form role="form">
                              <FormGroup>
                                <Row lg="12">
                                  <Col lg="12">
                                    <InputGroup className="input-group-alternative mb-3">
                                      {/*<InputGroupAddon addonType="prepend">*/}
                                        <InputGroupText>
                                          <i className="ni ni-lock-circle-open" />
                                        </InputGroupText>
                                      {/*</InputGroupAddon>*/}
                                      <Input
                                          placeholder="Password"
                                          type={this.state.showPassword ? "text" : "password"}
                                          autoComplete="off"
                                          onChange={this.onChangePassword}
                                          value={this.state.password}
                                      />
                                    {/* Toggle button for password visibility */}
                                    <InputGroupText
                                        onClick={this.togglePasswordVisibility}
                                        style={{ cursor: "pointer" }}
                                    >
                                        {this.state.showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </InputGroupText>
                                    </InputGroup>
                                  </Col>
                                </Row>
                                <Row lg="12">
                                  <Col lg="12">
                                    <InputGroup className="input-group-alternative mb-3">
                                      {/*<InputGroupAddon addonType="prepend">*/}
                                        <InputGroupText>
                                          <i className="ni ni-lock-circle-open" />
                                        </InputGroupText>
                                      {/*</InputGroupAddon>*/}
                                      <Input
                                          placeholder="Confirm email"
                                          type={this.state.showPasswordConfirm ? "text" : "password"}
                                          autoComplete="off"
                                          onChange={this.onChangePasswordConfirm}
                                          value={this.state.passwordConfirm}
                                      />
                                      {/* Toggle button for confirm password visibility */}
                                      <InputGroupText
                                          onClick={this.togglePasswordConfirmVisibility}
                                          style={{ cursor: "pointer" }}
                                      >
                                          {this.state.showPasswordConfirm ? <FaEyeSlash /> : <FaEye />}
                                      </InputGroupText>
                                    </InputGroup>
                                  </Col>
                                </Row>
                              </FormGroup>
                              <Row lg="12">
                                <Col lg="12">
                                  <span className="text-danger">{this.state.generalError}</span>
                                </Col>
                              </Row>
                              <div className="text-center">
                                <Button
                                    id="loginButton"
                                    className="mt-4"
                                    color="primary"
                                    type="button"
                                    onClick={this.validateAndSubmitForm}
                                    disabled={!this.resetButtonAvailable()}
                                >
                                  Request password reset email
                                </Button>
                              </div>
                            </Form>
                            <Modal
                                className="modal-dialog-centered"
                                size="sm"
                                isOpen={this.state.formModalResetConfirmed}
                                toggle={() => this.toggleModal("formModalResetConfirmed")}
                            >
                              <div className="modal-header">
                                <h2 style={{fontSize: '1rem'}} className="modal-title" id="modal-title-default">
                                  Password reset
                                </h2>
                                <button
                                    aria-label="Close"
                                    className="close"
                                    data-dismiss="modal"
                                    type="button"
                                    onClick={() => this.toggleModalAndMoveToHome("formModalResetConfirmed")}
                                >
                                  <span aria-hidden={true}>×</span>
                                </button>
                              </div>
                              <div className="modal-body p-0">
                                <Card className="bg-secondary shadow border-0">
                                  <CardBody className="px-lg-5 py-lg-5">
                                    <div className="text-center text-muted mb-4">
                                      Your password has been successfully reset, please sign in
                                    </div>
                                    <Form role="form">
                                      <div className="text-center">
                                        <Button
                                            className="my-4"
                                            color="primary"
                                            type="button"
                                            onClick={() => this.toggleModalAndMoveToHome("formModalResetConfirmed")}
                                        >
                                          <i className="fa fa-share-alt" aria-hidden="true"></i>
                                          <span className="btn-inner--text">Close</span>
                                        </Button>
                                      </div>
                                    </Form>
                                  </CardBody>
                                </Card>
                              </div>
                            </Modal>
                            <Modal
                                className="modal-dialog-centered"
                                size="sm"
                                isOpen={this.state.formModalResetIssue}
                                toggle={() => this.toggleModal("formModalResetIssue")}
                            >
                              <div className="modal-header">
                                <h2 style={{fontSize: '1rem'}} className="modal-title" id="modal-title-default">
                                  Password reset
                                </h2>
                                <button
                                    aria-label="Close"
                                    className="close"
                                    data-dismiss="modal"
                                    type="button"
                                    onClick={() => this.toggleModal("formModalResetIssue")}
                                >
                                  <span aria-hidden={true}>×</span>
                                </button>
                              </div>
                              <div className="modal-body p-0">
                                <Card className="bg-secondary shadow border-0">
                                  <CardBody className="px-lg-5 py-lg-5">
                                    <div className="text-center text-muted mb-4 text-warning">
                                      There was a problem resetting your password, please retry.
                                    </div>
                                    <Form role="form">
                                      <div className="text-center">
                                        <Button
                                            className="my-4"
                                            color="primary"
                                            type="button"
                                            onClick={() => this.toggleModal("formModalResetIssue")}
                                        >
                                          <i className="fa fa-share-alt" aria-hidden="true"></i>
                                          <span className="btn-inner--text">Close</span>
                                        </Button>
                                      </div>
                                    </Form>
                                  </CardBody>
                                </Card>
                              </div>
                            </Modal>
                            </>
                          }
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default withNavigateHook((props) => (
    <PasswordResetRequestConfirmation{...props} params={useParams()} />
));
